export default {
  geolocation: {
    lat: '48.1486',
    lng: '17.1086',
    label: '811 00 Bratislava',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
